module.exports = __webpack_public_path__ + "static/assets/76ecd505098c7523786059d99556d22e.png";